// Personel ve Roller sekmesinin saf yardımcıları (StaffTab + drawer'ları).

export const GENDER_OPTIONS = [
  { value: "Erkek", label: "Erkek" },
  { value: "Kadın", label: "Kadın" },
];

/** Ad/soyad alanlarından rakamları ayıklar. */
export const stripDigits = (s) => (s || "").replace(/[0-9]/g, "");

export const DOMAIN_LABELS = {
  dashboard: "Dashboard", patients: "Hastalar", appointments: "Randevular",
  treatments: "Tedaviler", anamnez: "Anamnez", tetkik: "Tetkik",
  medicines: "İlaçlar",
  diet: "Diyet", diseases: "Hastalıklar", lab: "Laboratuvar", schedule: "Takvim",
  reports: "Raporlar", users: "Kullanıcı Yönetimi", clinic: "Klinik Yönetimi",
  notifications: "Bildirimler", phoneCalls: "Telefon Görüşmeleri",
  doctorTemplates: "Doktor Şablonları", patientRelatives: "Hasta Yakınları",
  statistics: "İstatistikler", profile: "Profil", reservoirs: "Rezervuar",
  permissions: "İzinler", Genel: "Genel",
  clinicPatientLink: "Hasta Bağlantısı",
  examinations: "Muayene",
  pendingUsers: "Onay Bekleyen Kullanıcılar",
  performance: "Performans",
  whatsapp: "WhatsApp",
  "admin-audit": "Admin · Denetim",
  "admin-clinics": "Admin · Klinikler",
  "admin-dashboard": "Admin · Dashboard",
  "admin-devices": "Admin · Cihazlar",
  "admin-roles": "Admin · Roller",
  "admin-system-variables": "Admin · Sistem Değişkenleri",
};

/** İzin listesini "domain:action" önekine göre gruplar. */
export function groupPermissions(permissions) {
  const groups = {};
  (Array.isArray(permissions) ? permissions : []).forEach((perm) => {
    const key = typeof perm === "string" ? perm : perm.key || perm.code || perm.name || "";
    const desc = typeof perm === "object" ? perm.description || "" : "";
    const parts = key.split(":");
    const domain = parts.length > 1 ? parts[0] : "Genel";
    if (!groups[domain]) groups[domain] = [];
    groups[domain].push({ key, description: desc });
  });
  return groups;
}

/** Hesap durumunun rozet tonu (StatusPill). Metin her zaman yazılı. */
const STATUS_TONES = {
  Aktif: "success",
  Beklemede: "warning",
  "Askıya Alındı": "warning",
  Donduruldu: "warning",
  "Süresi Doldu": "warning",
  "Devre Dışı": "error",
  Reddedildi: "error",
  Silinmiş: "error",
};
export const statusToneOf = (status) => STATUS_TONES[status] || "neutral";

export const roleNameOf = (u, fallback) => u?.roleTemplate?.name || fallback || "Personel";
